module.exports = __webpack_public_path__ + "img/client-hiperidex.696e1e65.jpg";